import { Icon } from "@iconify/react";
import { Fragment, useState } from "react";
import AuthDialog from "../auth/AuthDialog";
import { HealthyLife, StartFreeTrail } from "./LandingPage";

function Faq({ question, answer, index, isOpen, onClick, last }) {
  return (
    <div
      className={`flex flex-1 flex-col p-6 gap-4 ${last ? "" : "border-b-[1px]"
        } border-new-gray`}
    >
      <Fragment key={index}>
        <div
          className="flex flex-row gap-8 justify-center items-center cursor-pointer"
          onClick={() => onClick()}
          aria-expanded={isOpen}
          {...(isOpen && { "aria-controls": index })}
        >
          <div className="flex justify-center items-center rounded-full bg-primary-paleBlack p-2 h-8 w-8 border-2 border-white ">
            <Icon
              icon="ic:baseline-arrow-forward-ios"
              className={` flex text-primary-white ${isOpen ? "rotate-90 " : " "
                } transform`}
            />
          </div>

          <p
            className={`${isOpen ? "font-bold " : " "
              } flex flex-1  font-open-sans text-white text-xl `}
          >
            {question}
          </p>
        </div>
        {isOpen && (
          <p className="ml-16 flex flex-1  font-open-sans text-white text-opacity-80 leading-9">
            {answer}
          </p>
        )}
      </Fragment>
    </div>
  );
}

export default function FaqPage() {
  const faqs = [
    {
      question: "Will my image or video be recorded?",
      answer:
        "We do not record any image/video of yours. We always seek your prior consent, incase of any need along with a detailed explanation for the ask.",
    },
    {
      question:
        "How safe is it for fitness as there is no actual human intervention?",
      answer:
        "All the exercises are coded and go through multiple phases of testing before it is shared with you. The guidance is without any human perception and hence, we have an ~80% accuracy rate. In a few cases, it is safer than doing these with a semi or non-qualified trainer.",
    },
    {
      question: "How does it help me to reach my fitness and health goals?",
      answer:
        "If the recommended programs are followed thoroughly and performed correctly as per the instructions, you will be mostly likely to meet your desired goals. Any kind of deviations like inadequate sleep, improper nutritional intake, high stress levels, personal habits such as smoking and drinking are beyond the purview of getactyv might affect your desired results.",
    },
    {
      question:
        "Are the recommendations provided truly personalised, or is it a set of predefined workouts?",
      answer: (
        <span>
          <strong>
            <i>getactyv’s Intelligent recommendation engine™</i>
          </strong>
          {"   "}
          takes into account the responses to your onboarding questions,
          determines your difficulty level, (beginner, intermediate, advanced)
          in your user cohort, and your desired goals, and maps everything to
          our extensive exercise library. In a few seconds, our engine designs a
          unique program for you based on the above inputs. It has an inbuilt
          progression feature for your exercises and programs to gradually and
          safely navigate you toward your desired goals.
        </span>
      ),
    },
    {
      question:
        "Are the prices subject to change in the middle of my membership?",
      answer:
        "No. Once you have signed up, any intermittent product upgrades will be done at ZERO ADDITIONAL COST.",
    },
    {
      question:
        "How much space will I need to do my workout? What kind of camera and wifi bandwidth is required for a smooth routine?",
      answer: (
        <span>
          You will need a free space of 6x6 ft.
          <br />A smartphone, laptop or desktop made post 2018. Wi-fi with an
          average speed of 25-30 Mbps is sufficient enough for the smooth
          function of the platform.{" "}
        </span>
      ),
    },
    {
      question: "Which browsers are compatible with the platform?",
      answer: (
        <span>
          <strong>For Desktop / Laptop:</strong>
          <br />
          <li>Google Chrome (96+)</li>
          <li>Microsoft Edge (97+)</li>
          <li>Safari</li>
          <li>Firefox is not supported</li>
          <br />
          <strong>For Mobile Devices:</strong>
          <br />
          <li>Chrome</li>
          <li>Edge</li>
          <li>iOS - Safari is not supported</li>
        </span>
      ),
    },
    {
      question: "Is there any native app for getactyv?",
      answer:
        "Right now our platform works on a web-based model. The native app is under development.",
    },
    {
      question:
        "How does getactyv handle people with muscle pains, post-surgical issues, or any other deformities? ",
      answer:
        "We have a rehab section catering to specific conditions of joints and muscles. However, these are only exercise interventions and shouldn’t be considered as medical advice. If you have any serious medical condition, we recommend you to refer to a qualified medical practitioner before starting any program.",
    },
    {
      question: "What all age-group can benefit from the platform?",
      answer: "The platform is suited for anybody above 12 years of age",
    },
    {
      question: "What type of equipment is required for the workout?",
      answer:
        "Although there are a few equipment-based exercises, it is up to you whether to use them or not.",
    },
    {
      question: "Do I need to workout everyday?",
      answer:
        "Anywhere between 15 - 45 minutes of workout between 2-5 days a week.",
    },
    {
      question: "How can I increase lean mass ?",
      answer:
        "Following a progressive strength based routine with equipment or bodyweight, between 3-5 days a week will give optimum results to develop lean mass, provided a good nutrition program is followed with the right percentages  of macronutrients like carbohydrates, proteins and fats.",
    },
    {
      question: "What training should I do to lose weight?",
      answer:
        "The training for losing or gaining weight doesn't differ much, it's the calorie deficit which accelerates fat loss. A good mix of strength training and cardio based workouts with some flexibility routines should do the job. ",
    },
    {
      question: "How often should I rest?",
      answer:
        "Depending on your training history, age and type of workout done, rest days would vary between 1 - 4 days a week.",
    },
    {
      question: "When should I stretch and how often?",
      answer:
        "Ideally you should stretch after every workout session, whether it's strength or cardio based ",
    },
    {
      question: "What can you do about muscle soreness?",
      answer:
        "Muscle soreness is a natural physiological response post intense training, although not every intense program produces soreness. Generally doing some very low intensity cardio like walking and/or working the same muscle groups with very light loads and volume the next day for a short period of time, accelerates the recovery process.  ",
    },
    {
      question: "How long does it take to see results? ",
      answer:
        "It depends on your goals, age, training history and body type. It can be safely said there are no magic pills there, hard work, dedication and smart training will provide the results in due course of time based on the variables mentioned above.",
    },
    {
      question: "Is working out better in the mornings?",
      answer:
        "There is no such time as the best time to workout, anytime you can make time is the best time. Although there is a school of thought which says that late afternoons to early evenings may be good as all hormonal functionings are at peak levels at the time. There is no conclusive evidence on that though. ",
    },
    {
      question: "How do I get a six pack? ",
      answer:
        "Although following a goal of only a six pack may not be the best idea, reducing body fat percentage to around 10-12% with the right kind of strength and cardio based training along with sound nutrition should get you close. But again a six pack should be a by-product of training, not a goal ideally.",
    },
    {
      question: "What type of training do I need to get stronger? ",
      answer:
        "A strength training program performed with the right technique and form, using more compound movements as opposed to isolation movements, complemented by good nutrition, sleep and recovery should help you get stronger.  ",
    },
    {
      question: "How does exercise help mentally?",
      answer:
        "Exercise not only improves the muscular and cardiovascular systems but also the neurological systems. It helps regulate the nervous system and optimize hormonal functions. Hormones, like endorphins, called the happy hormones are released post exercise which puts you in a better mental state. So habit formation with exercise definitely helps with mental well being. ",
    },
  ];
  const [showAuth, setShowAuth] = useState(false);
  const [selectedFaq, setSelectedFaq] = useState(0);
  return (
    <div className="flex flex-col w-full h-full bg-primary-midBlack">
      <AuthDialog open={showAuth} setOpen={setShowAuth} />
      <div className="w-full  py-20">
        <div className="px-5 md:px-32">
          <a href="/">
            <p className="text-white font-bold flex flex-row items-center gap-1">
              <span>
                <Icon
                  icon="ic:baseline-arrow-right-alt"
                  className="rotate-180"
                />
              </span>
              Go back to the home page
            </p>
          </a>
          <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug mt-10">
            FAQs
          </p>
          <div className="mt-10">
            {faqs.map((faq, index) => {
              return (
                <Faq
                  {...faq}
                  index={index}
                  isOpen={index == selectedFaq}
                  onClick={() => {
                    setSelectedFaq(index);
                  }}
                  last={faqs.length - 1 == index}
                />
              );
            })}
          </div>
        </div>
      </div>
      <HealthyLife
        openAuth={() => {
          setShowAuth(true);
        }}
      />
      <StartFreeTrail
        openAuth={() => {
          setShowAuth(true);
        }}
      />
    </div>
  );
}
